module.exports = __webpack_public_path__ + "static/media/portfolio1.443a3751.webp";